import React from "react";
import SiteListRow from "./SiteListRow";

const SiteList = (props) => {
  const { sitesData, handleDropDownChange, onDeleteSite, onOpenSiteInfo } =
    props;

  return (
    <div className="flex flex-col gap-[1.375rem] pt-[1.375rem] h-full max-h-[90%] overflow-auto box-border ">
      {Array.isArray(sitesData) && sitesData.length > 0 ? (
        sitesData.map((site, index) => (
          <SiteListRow
            key={site.Site_index ?? `site-${index}`}
            site={site}
            index={index}
            handleDropDownChange={handleDropDownChange} // Pass directly
            onRowClick={(i) => props.onRowClick(i)}
            onOpenSiteInfo={(i) => onOpenSiteInfo(i)}
          />
        ))
      ) : (
        <p className="text-white">No sites found.</p>
      )}
    </div>
  );
};

export default SiteList;
